import { API_V2 } from 'constant/apiUrl'
import type { Fetch } from 'lib/fetch/type'
import { type IAssetV2 } from 'type/asset'
import type { IRespV2 } from 'type/common'
import type {
  IExploresCommunityV2,
  IInStreamCommunityV2,
  IInStreamSpotV2,
  ISearchExploreSpot
} from 'type/feed'
import type { searchExploreReq } from 'type/search'
import type { IUserV2 } from 'type/user'

// V2
export const exploreSpotV2 = async (
  fetcher: Fetch,
  req: searchExploreReq
): Promise<{ spots: ISearchExploreSpot[] }> => {
  const res = await fetcher(API_V2.NEWS_FEED_V2 + '/explores/spot', {
    method: 'POST',
    body: req
  })

  return res.data
}

export const exploreCommunityV2 = async (
  fetcher: Fetch,
  req: searchExploreReq
): Promise<{
  communities: IExploresCommunityV2[]
}> => {
  const res = await fetcher(API_V2.NEWS_FEED + '/explores/community', {
    method: 'POST',
    body: req
  })

  return res.data
}

export const exploreCommunityPageV2 = async (
  fetcher: Fetch,
  req: searchExploreReq
): Promise<{
  communities: IExploresCommunityV2[]
}> => {
  const res = await fetcher(API_V2.NEWS_FEED + '/explores/community/page', {
    method: 'POST',
    body: req
  })

  return res.data
}

/**
 *
 * @param query ex: keyword=cat&lang=zh_tw&lat=25.05755&level0=tw&lng=121.6120982&user_id=184947853029172838%EF%BC%96&country_code=tw&size=20&page_token=xxxx
 * @returns
 */
export const searchSpotV2 = async (
  fetcher: Fetch,
  query: string | URLSearchParams
): Promise<
  IRespV2<{
    spots: IInStreamSpotV2[]
    next_page_token: string
  }>
> => {
  const url = new URL(API_V2.NEWS_FEED + '/search/spot')
  url.search = `?${query}`

  const res = await fetcher(url.toString())

  return res
}

/**
 *
 * @param query ex: keyword=cat&lang=zh_tw&lat=25.05755&level0=tw&lng=121.6120982&user_id=184947853029172838%EF%BC%96
 * @returns
 */
export const searchCommunityV2 = async (
  fetcher: Fetch,
  query: string | URLSearchParams
): Promise<
  IRespV2<{
    communities: IInStreamCommunityV2[]
  }>
> => {
  const url = new URL(API_V2.NEWS_FEED + '/search/community')
  url.search = `?${query}`

  const res = await fetcher(url.toString())

  return res
}

/**
 *
 * @param query ex: keyword=cat&lat=25.05755&lng=121.6120982&country_code=tw&user_id=184947853029172838%EF%BC%96
 * @returns
 */
export const searchUserV2 = async (
  fetcher: Fetch,
  query: string | URLSearchParams
): Promise<
  IRespV2<{
    users: IUserV2[]
  }>
> => {
  const url = new URL(API_V2.NEWS_FEED + '/search/user')
  url.search = `?${query}`

  const res = await fetcher(url.toString())

  return res
}

/**
 *
 * @param query ex: keyword=fo&lang=zh_tw&lat=25.0574526&country=tw&lng=121.6122679&user_id=1844388978879365120
 */
export const getAutoCompleteV2 = async (
  fetcher: Fetch,
  query: string | URLSearchParams
): Promise<
  IRespV2<{
    community_list: {
      asset: IAssetV2 | null
      id: string
      user_id: string
      title: string
      comment_count: number
      community_joined_count: number
      type: number
      is_join: boolean
    }[]
    user_list: IUserV2[]
  }>
> => {
  const url = new URL(API_V2.NEWS_FEED + '/search/autocomplete')
  url.search = `?${query}`

  const res = await fetcher(url.toString())

  return res
}
